import styled, { css } from 'styled-components';

export const FormMessage = styled.p`
  grid-column: ${({ $gridColumn }) => $gridColumn || '1 / span 2'};
  margin: ${({ $margin }) => $margin || '0.5rem 0'};
  color: ${({ $error }) => ($error ? 'red' : 'green')};
  ${({ $textAlign }) =>
    $textAlign && css`
      text-align: ${$textAlign};
    `}
`;